import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './context/AppContext';
import { MessageProvider } from './context/MessageContext';
import $ from "jquery";
window.jQuery = $;
window.$ = $;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MessageProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </MessageProvider>
  </React.StrictMode>
);

reportWebVitals();
